import { AbstractServiceConfig } from 'services/AbstractService'
import { IS_BROWSER } from 'client/constants'

export const applyServiceHeaders = (config: AbstractServiceConfig): AbstractServiceConfig => {
  // No need to modify headers in the browser environment
  if (IS_BROWSER) {
    return config
  }

  return {
    ...config,
    headers: {
      ...config.headers,
      'Accept-Encoding': 'br, gzip, deflate',
    },
  }
}
